import { ApiBaseService } from 'eightcap-core/api/crud.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GoodwillRequest, GoodwillResponse } from '@eightcap/core';
import { map } from 'rxjs/operators';

@Injectable()
export class GoodwillService extends ApiBaseService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/service/metatrader/reset_balance');
    }

    post(data: GoodwillRequest[]): Observable<GoodwillResponse[]> {
        return this.httpClient
            .post<GoodwillResponse[]>(this.basePath, { data })
            .pipe(map((res: any) => res && res.data));
    }
}
